exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gris-couleur[data-v-777910d6]{background-color:#e0e0e0}.white-couleur[data-v-777910d6]{color:#fff}.v-card__title[data-v-777910d6]{font-size:1.2rem;font-weight:400;letter-spacing:normal;line-height:1.5rem}.titreEvent[data-v-777910d6]{text-decoration:none}.titreEvent[data-v-777910d6]:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-777910d6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/events/index-coming.vue
// module id = F0H8
// module chunks = 1